module.exports = __webpack_public_path__ + "static/img/nullStatus.7b3fbb8d.png";